import Swal from 'sweetalert2'

class Toast {
    custom(text, icon) {
        Swal.fire({html: '<p>' + text + '</p>', icon,  timer: 3000, showConfirmButton: false, toast: true, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }

    campaignCreated() {
        Swal.fire({html: '<p>Campaign saved</p>', icon: 'success',  timer: 3000, showConfirmButton: false, toast: true, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }

    failedInsert(message) {                    
        Swal.fire({html: `<p>${{message}}</p>`, icon: 'error',  timer: 3000, showConfirmButton: false, toast: true, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }

    invalidInput() {
        Swal.fire({html: '<p>Please check your input</p>', icon: 'error', timer: 3000, showConfirmButton: false, toast: true, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }

    campaignDeleted() {
        Swal.fire({html: '<p>Campaign deleted !!</p>', icon: 'success', showConfirmButton: false, toast: true, position: 'bottom-end', timer: 3000, customClass: {container: 'popup-box-container'}});
    }

    noEmailEntered (message) {
        Swal.fire({html: `<p>${message}</p>`, icon: 'warning', timer: 5000, showConfirmButton: true, toast: false, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }

    termsAndConditionsMissing (message) {
        Swal.fire({html: `<p>${message}</p>`, icon: 'warning', timer: 5000, showConfirmButton: true, toast: false, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }

    responseMessageError (message) {
        Swal.fire({html: `<p>${message}</p>`, icon: 'error', timer: 5000, toast: false, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }

    errorMessage (message) {
        Swal.fire({html: `<p>${message}</p>`, icon: 'error', timer: 5000, toast: false, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }
    
    simpleMessage (message) {
        Swal.fire({html: `<p>${message}</p>`, timer: 5000, toast: false, showConfirmButton: false, position: 'bottom-end', customClass: {container: 'popup-box-container'}})
    }

    successMessage (message) {
        Swal.fire({html: `<p>${message}</p>`, icon: 'success', timer: 3000, showConfirmButton: false, toast: true, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }

    logout () {        
        Swal.fire({html: '<p>Logged out</p>', icon: 'success',  timer: 3000, showConfirmButton: false, toast: true, position: 'bottom-end', customClass: {container: 'popup-box-container'}});
    }

    confirmCancel(callback){
        Swal.fire({
            title: 'Are you sure?',
            text: "All changes will be lost!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, cancel!'
          }).then((result) => {
              if(result.value === true){
                callback()
              }
          })
    }
}

export default new Toast()